import { PlayFilled as l } from "./play-filled.js";
import { PlayFilledLight as o } from "./play-filled-light.js";
const i = {
  PlayFilled: l,
  PlayFilledLight: o
};
export {
  i as Other
};
